import { render } from "./SettingsPanelAutomation.vue?vue&type=template&id=c2a48162"
import script from "./SettingsPanelAutomation.vue?vue&type=script&lang=ts"
export * from "./SettingsPanelAutomation.vue?vue&type=script&lang=ts"

import "./SettingsPanelAutomation.vue?vue&type=style&index=0&id=c2a48162&lang=scss"
script.render = render

export default script